<template>
  <div class="evaluate-manage">
    <van-tabs
      v-model="active"
      title-active-color="#36B274"
      title-inactive-color="#333333"
      color="#36B274"
    >
      <van-tab title="初评计划">
        <van-swipe class="my-swipe" indicator-color="#3BC480" v-if="summaryList.first">
          <van-swipe-item v-for="item in summaryList.first" :key="item.id">
            <div class="content">
              <p class="title">{{item.name}}</p>
              <van-circle
								class="circle"
                layer-color="#EAEEF2"
                color="#3BC480"
                :value="Number(item.percent) > 0 ? Number(item.percent) : 0"
                :rate="Number(item.percent)"
                :speed="Number(item.totalNum)"
								:stroke-width="80"
                :text="Number(item.percent) > 0 ? Number(item.percent) + '%' : 0 + '%'"
              />
							<div class="tip">完成率</div>
              <div class="show">
                <span>应评</span>
                <span>已评</span>
              </div>
              <div class="d-flex">
                <div class="data d-flex flex-dircetion-column">
                  <span class="value">{{item.totalNum}}</span>
                  <span class="cloumn">应评数(家)</span>
                </div>
                <div class="data d-flex flex-dircetion-column">
                  <span class="value">{{item.surplusNum}}</span>
                  <span class="cloumn">待评数(家)</span>
                </div>
                <div class="data d-flex flex-dircetion-column">
                  <span class="value">{{item.alreadyNum}}</span>
                  <span class="cloumn">已评数(家)</span>
                </div>
              </div>
            </div>
            <div class="btn" @click="goPath(item.id)">查看执行情况</div>
          </van-swipe-item>
        </van-swipe>
      </van-tab>
      <van-tab title="复评计划">
        <van-swipe class="my-swipe" indicator-color="#3BC480" v-if="summaryList.repeat">
          <van-swipe-item v-for="item in summaryList.repeat" :key="item.id">
            <div class="content">
              <p class="title">{{item.name}}</p>
              <van-circle
								class="circle"
                layer-color="#EAEEF2"
                color="#3BC480"
                :value="Number(item.percent) > 0 ? Number(item.percent) : 0"
                :rate="Number(item.percent)"
                :speed="Number(item.totalNum)"
								:stroke-width="80"
                :text="Number(item.percent) > 0 ? Number(item.percent) + '%' : 0 + '%'"
              />
							<div class="tip">完成率</div>
              <div class="show">
                <span>应评</span>
                <span>已评</span>
              </div>
              <div class="d-flex">
                <div class="data d-flex flex-dircetion-column">
                  <span class="value">{{item.totalNum}}</span>
                  <span class="cloumn">应评数(家)</span>
                </div>
                <div class="data d-flex flex-dircetion-column">
                  <span class="value">{{item.surplusNum}}</span>
                  <span class="cloumn">待评数(家)</span>
                </div>
                <div class="data d-flex flex-dircetion-column">
                  <span class="value">{{item.alreadyNum}}</span>
                  <span class="cloumn">已评数(家)</span>
                </div>
              </div>
            </div>
            <div class="btn" @click="goPath(item.id)">查看执行情况</div>
          </van-swipe-item>
        </van-swipe>
      </van-tab>
    </van-tabs>
    <!-- <div class="btn" @click="goPath">查看执行情况</div> -->
  </div>
</template>
<script>
import Vue from "vue";
import { Circle, Swipe, SwipeItem } from "vant";
Vue.use(Circle);
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  name: "EvaluateManage",
  data() {
    return {
      firstRate: 0,
      secondRate: 0,
      active: "",
    };
  },
  props: {
    summaryList: {
      type: Object,
      default: {}
    },
    cityChangeFlag: {
      type: Boolean,
      default: true
    }
    
  },
  mounted() {
    console.log('this.summaryList',this.summaryList)
  },
  computed: {
    text() {
      return this.firstRate.toFixed(0) + "%";
    },
    text1() {
      return this.secondRate.toFixed(0) + "%";
    },
  },
  watch: {},
  methods: {
		goPath(evaluationId) {
			this.$router.push({
				path: '/integrity/evaluationStatistical',
        query: {
          evaluationId,
          cityChangeFlag: this.cityChangeFlag
        }
			})
		}
	},
};
</script>

<style lang="less" scoped>
.content /deep/ .van-circle__text {
	color: #3BC480;
	font-size: 20px;
	top: 46%;
  left: 5px;
}
 /deep/ .van-swipe__indicators {
  bottom: 75px;
}
/deep/ .van-swipe__indicator {
  width: 20px;
  height: 3px;
  border-radius: 2px;
}
.d-flex {
  display: flex;
  align-items: center;
}
.flex-dircetion-column {
  flex-direction: column;
}
.value {
  color: #333333;
  font-size: 18px;
}
.cloumn {
  color: #999999;
  font-size: 12px;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 21px auto;
	.tip {
		position: absolute;
		color: #999999;
		top: 36%;
	}
  .title {
    max-width: 262px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 18px;
  }
  .show {
    margin-top: 10px;
    margin-bottom: 10px;
    span {
      font-size: 10px;
      color: #999999;
      &:first-of-type {
        &::before {
          content: " ";
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #eaeef2;
          margin-right: 5px;
        }
      }
      &:last-of-type {
        margin-left: 34px;
        &::before {
          content: " ";
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #3bc480;
          margin-right: 5px;
        }
      }
    }
  }
}
.data {
  width: 117px;
  span {
    &:first-of-type {
      margin-bottom: 5px;
    }
  }
}
.btn {
  width: 200px;
  height: 32px;
  border: 1px solid #3bc480;
  border-radius: 244px;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  color: #3bc480;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
